import { type KeyboardEvent, type ReactNode } from 'react';
import type { SearchableColumn } from './types';
import s from './grid-search.module.scss';

interface ColumnDropdownProps {
    grouped: Record<string, SearchableColumn[]>;
    onSelect: (col: SearchableColumn) => void;
    onKeyDown: (
        e: KeyboardEvent<HTMLButtonElement>,
        col: SearchableColumn,
    ) => void;
}

export function ColumnDropdown({
    grouped,
    onSelect,
    onKeyDown,
}: ColumnDropdownProps): ReactNode {
    return (
        <div className={s.dropdown} role="listbox">
            {Object.entries(grouped).map(([groupName, cols]) => (
                <div key={groupName || '_root'}>
                    {groupName ? (
                        <div className={s.dropdownGroup}>{groupName}</div>
                    ) : null}
                    {cols.map((col) => (
                        <button
                            key={col.colId}
                            type="button"
                            className={s.dropdownItem}
                            role="option"
                            aria-selected={false}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                onSelect(col);
                            }}
                            onKeyDown={(e) => {
                                onKeyDown(e, col);
                            }}
                        >
                            {col.headerName}
                            {col.inputType !== 'text' ? (
                                <span className={s.columnType}>
                                    {col.inputType}
                                </span>
                            ) : null}
                        </button>
                    ))}
                </div>
            ))}
        </div>
    );
}
